import { SxProps, Theme } from '@mui/material';

export const labelStyle: SxProps<Theme> = {
	fontFamily: 'Montserrat',
	color: '#FFFFFF',
	fontSize: '15px',
	fontWeight: 600,
	lineHeight: '21px',
	mb: '8px',

	'&.Mui-focused': {
		color: '#FFFFFF',
	},
	'&.Mui-disabled': {
		color: '#FFFFFF',
	},
	'&.Mui-error': {
		color: '#FFFFFF',
	}
};

export const descriptionStyle: SxProps<Theme> = {
	fontFamily: 'Montserrat',
	color: '#FFFFFF',
	fontSize: '13px',
	fontWeight: 400,
	lineHeight: '21px',
	mb: '8px',

	'&.Mui-focused': {
		color: '#FFFFFF',
	},
	'&.Mui-disabled': {
		color: '#FFFFFF',
	},
	'&.Mui-error': {
		color: '#FFFFFF',
	}
};

export const helperTextStyle: SxProps<Theme> = {
	mx: 0,
	mt: '4px',
	fontSize: '13px',
	fontWeight: 500,
	lineHeight: '21px',
	color: '#FFFFFF',
	'&.Mui-focused': {
		color: '#FFFFFF',
	},
	'&.Mui-disabled': {
		color: '#FFFFFF',
	},
	'&.Mui-error': {
		color: '#FF0606',
	}
};
